import React, { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './ServiceRequestScheduleForm.scss';
import { ICONS } from 'src/common/constants';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Row from '../Row';
import { fetchServiceProviders } from 'src/store/actions/contacts';
import Loader from '../Loader';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { clearSuiteUsers } from 'src/store/actions/suites';
import FontAwesomeIcon from '../Icon';
import { updateServiceRequest } from 'src/store/actions/serviceRequest';
import Tile from '../Tile';
import CreatableSelect from 'react-select/creatable';
import { fetchServiceRequestTags } from 'src/store/actions/formOptions';
import { BrandingContext } from 'src/branding/BrandingContextProvider';
import Textarea from '../Textarea';

interface ServiceRequestEditFormProps {
  serviceRequest: any;
  onClose: () => void;
  handleSaveScheduledAppointment: (
    formData: any,
    serviceRequestId: any
  ) => void;
  [key: string]: any;
}

const ServiceRequestEditForm = (props: ServiceRequestEditFormProps) => {
  const dispatch = useDispatch();
  const branding = useContext(BrandingContext);

  const loader = useSelector(selectFormLoader);
  const user = useSelector(selectAuthenticatedUser);
  const types = useSelector((state: any) => state.formOptions.types);
  const serviceRequestTags = useSelector(
    (state: any) => state.formOptions.serviceRequestTags
  );

  const [issueType, setIssueType] = useState<string>('');
  const [issueTypeId, setIssueTypeId] = useState<string>('');
  const [images, setImages] = useState<any[]>(
    props.serviceRequest.attachment
      ? JSON.parse(props.serviceRequest.attachment)
      : []
  );
  const [tags, setTags] = useState<any[]>([]);
  const [description, setDescription] = useState<string>('');

  const onClearSuiteUsers = () => dispatch(clearSuiteUsers() as any);
  const onFetchServiceProviders = (params: any) =>
    dispatch(fetchServiceProviders(params) as any);
  const onUpdateServiceRequest = (data: any, context: any) =>
    dispatch(updateServiceRequest(data, context) as any);
  const onFetchServiceRequestTags = () =>
    dispatch(fetchServiceRequestTags() as any);

  useEffect(() => {
    const { serviceRequest } = props;
    onFetchServiceRequestTags();
    onClearSuiteUsers();

    let params = {
      Name: serviceRequest.issueType.name,
      id: serviceRequest.propertyId,
    };

    setIssueType(serviceRequest.issueType.name);
    setIssueTypeId(serviceRequest.issueType.id);
    setDescription(serviceRequest.description);

    let selectedtags: any[] = [];
    let tagsData =
      serviceRequest.tags && serviceRequest.tags.length > 0
        ? serviceRequest.tags
        : [];

    if (tagsData && tagsData.length > 0) {
      tagsData.forEach((tag: any) => {
        selectedtags = [...selectedtags, { value: tag.id, label: tag.name }];
      });
    }

    setTags(selectedtags);
    onFetchServiceProviders(params);
  }, []);

  const updateServiceRequestHandler = () => {
    let serviceRequestTagging: any[] = [];
    let tagsData = tags;

    if (tagsData && tagsData.length > 0) {
      tagsData.forEach((tag: any) => {
        if (tag.__isNew__) {
          serviceRequestTagging = [
            ...serviceRequestTagging,
            { name: tag.value },
          ];
        } else {
          serviceRequestTagging = [...serviceRequestTagging, { id: tag.value }];
        }
      });
    }

    let data = {
      id: props.serviceRequest.id,
      subject: props.serviceRequest.subject,
      description: description,
      Attachment: JSON.stringify(images).toString(),
      issueType: issueType,
      IssueTypeId: issueTypeId,
      creatorId: user.id,
      tags: serviceRequestTagging,
    };

    onUpdateServiceRequest(data, 'EditServiceRequest');
  };

  const onSetTags = (newValue: any) => {
    setTags(newValue);
  };

  const { onClose } = props;

  return (
    <Form
      headline={`Edit ${branding?.branding?.text?.serviceRequest ?? 'Service Request'}`}
      onClose={() => {
        onClose();
      }}
      onSubmit={() => {
        updateServiceRequestHandler();
        onClose();
      }}
      actions={
        <>
          {loader ? <Loader center={true} /> : null}
          <Button
            color="semantic"
            size="small"
            label="Cancel"
            onClick={() => {
              onClose();
            }}
          />
          <Button
            color="teal"
            type="submit"
            size="small"
            label="Save Changes"
            style={{ marginLeft: '1em' }}
          />
        </>
      }
      component={
        <Row mdCenter style={{ overflow: 'visible' }}>
          <Col chonky xs="12" md="8" style={{ marginTop: '2em' }}>
            <Row granola>
              {types.map((issueTypeItem: any) => (
                <Col granola key={issueTypeItem.name} xs="6" md="4">
                  <Tile
                    icon={
                      <FontAwesomeIcon
                        weight="light"
                        glyph={ICONS[issueTypeItem.name]}
                      />
                    }
                    active={issueTypeItem.name === issueType}
                    onClick={() => {
                      setIssueType(issueTypeItem.name);
                      setIssueTypeId(issueTypeItem.id);
                    }}
                    title={
                      issueTypeItem.name === 'Heating/Cooling'
                        ? 'Heating / Cooling'
                        : issueTypeItem.name
                    }
                    size="tiny"
                  />
                </Col>
              ))}
            </Row>
            <label className="textarea__label">Tags</label>
            <CreatableSelect
              placeholder="Add or create tags"
              closeMenuOnSelect={false}
              isClearable
              isMulti
              options={
                serviceRequestTags.length > 0
                  ? serviceRequestTags.map((item: any) => ({
                      value: item.id,
                      label: item.name,
                    }))
                  : []
              }
              value={tags}
              onChange={(newValue, actionMeta) => onSetTags(newValue)}
            />

            <label className="textarea__label" style={{ marginTop: '.75em' }}>
              Description
            </label>
            <Textarea
              className="textarea"
              value={description}
              onChange={(e: any) => setDescription(e.target.value)}
            />
          </Col>
        </Row>
      }
      footer={undefined}
      strapline={undefined}
      onExit={undefined}
    />
  );
};

export default ServiceRequestEditForm;
